import { render, staticRenderFns } from "./AlarmsCard.vue?vue&type=template&id=a45c5ea8&"
import script from "./AlarmsCard.vue?vue&type=script&lang=js&"
export * from "./AlarmsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/fiksucity/city-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a45c5ea8')) {
      api.createRecord('a45c5ea8', component.options)
    } else {
      api.reload('a45c5ea8', component.options)
    }
    module.hot.accept("./AlarmsCard.vue?vue&type=template&id=a45c5ea8&", function () {
      api.rerender('a45c5ea8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sidebar/alarms/AlarmsCard.vue"
export default component.exports